import { NotificationManager } from "react-notifications";

import UserApi from "../../../../../services/user-service";

const updateUserPassword = async ({
  values,
  setSubmitting,
  closeModal,
  resetForm,
}) => {
  try {
    const { memberId, password } = values;
    const response = await UserApi.updateUserPassword({
      memberId,
      password: { password },
    });
    if (!response.success) {
      NotificationManager.error("Password update failed!", "Error");
      return;
    }
    NotificationManager.success("Password updated successfully!", "Success");
    closeModal();
    resetForm();
  } catch (error) {
    NotificationManager.error("Password update failed!", "Error");
  } finally {
    setSubmitting(false);
  }
};

const ModalDomain = {
  updateUserPassword,
};

export default ModalDomain;
